import React from 'react';
import { ProgramRequestModalShell } from './ProgramRequestModalShell';

export const EditProgramRequestModal = props => (
    <ProgramRequestModalShell {...props} mode="edit" />
);
